/** 効果測定の暦日は、端末のタイムゾーンにかかわらず日本時間で扱う（営業日切替とは別）。 */
export function reportDateJst(date: Date): string {
  return new Date(date.getTime() + 9 * 60 * 60 * 1000).toISOString().slice(0, 10);
}

export function reportPeriodJst(from: string, to: string): { from: string; to: string } {
  const validDate = (value: string): boolean => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
    const parsed = new Date(`${value}T00:00:00+09:00`);
    return Number.isFinite(parsed.getTime()) && reportDateJst(parsed) === value;
  };
  if (!validDate(from) || !validDate(to)) throw new Error('開始日と終了日を正しく指定してください。');
  if (from > to) throw new Error('終了日は開始日以降にしてください。');
  return {
    from: new Date(`${from}T00:00:00.000+09:00`).toISOString(),
    to: new Date(`${to}T23:59:59.999+09:00`).toISOString(),
  };
}
